import { StandardDialogFooter } from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, { useState } from "react";
import ActionDialogOrderList from "../order-list/action-dialog-order-list";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import ordersService from "../../../../services/orders.service";
import EmptyScanPopup from "./shared/empty";
import { useAppSelector } from "../../../../redux/store";
import { MessageSections } from "../../../../pages/components/message/message";
import {
  getMessage,
  initToast,
} from "../../../../pages/shared/helper-functions";
import { ActionDialogContent } from "./shared/styled";
import { standardDialogColumns } from "./shared/columns";
import { TrackNumberInput } from "./track-number-input";

const ScanForSearch = ({
  onCancel,
  ordersUpdated,
  preSelectedOrders,
}: ScanForSearchDialogProps) => {
  const [orders, setOrders] = useState(preSelectedOrders || []);
  const { orderStateId } = useAppSelector((state) => state.ordersReducer);

  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  function searchForOrder(trackingNumberToSearch: string) {
    if (
      !!trackingNumberToSearch.length &&
      !orders.some((order) =>
        order.products.some(
          (product) => product.trackingNumber === trackingNumberToSearch,
        ),
      )
    ) {
      const filter = { textQuery: trackingNumberToSearch };

      if (filter) {
        ordersService
          .getOrderByGivenFilterCriteria(filter)
          .then((order) => {
            if (order) {
              if (order.trackRecord[0]?.state.orderStateId === orderStateId) {
                const newOrders = [...orders, order];
                updateOrders(newOrders);
              } else {
                initToast(
                  getMessage(
                    "order_in_other_state",
                    MessageSections.ORDERS,
                    messageCache,
                    languageId,
                  ),
                  "error",
                );
              }
            } else {
              initToast(
                getMessage(
                  "order_not_found",
                  MessageSections.ORDERS,
                  messageCache,
                  languageId,
                ),
                "error",
              );
            }
          })
          .catch((reason) => {
            console.log(reason);
          });
      }
    }
  }

  function updateOrders(orders: OrderModel[]) {
    setOrders(orders);
    ordersUpdated(orders);
  }

  return (
    <>
      <ActionDialogContent>
        {/*<ToolPanel selectedOrders={ordersMap} isWarehouseWorker={true} orderStateId={'all'}/>*/}
        <TrackNumberInput onEnter={searchForOrder} />

        {orders.length ? (
          <ActionDialogOrderList
            orders={orders}
            columns={standardDialogColumns}
            updateOrders={updateOrders}
          />
        ) : (
          <EmptyScanPopup />
        )}
      </ActionDialogContent>

      <StandardDialogFooter
        exportableOrders={orders}
        onCancel={() => onCancel()}
      />
    </>
  );
};

interface ScanForSearchDialogProps {
  onCancel: () => void;
  preSelectedOrders?: OrderModel[];
  ordersUpdated: (orders: OrderModel[]) => void;
}

export default ScanForSearch;
